export const messages = {
  en: {
    operationalAnalysis: {
      allCommunities: 'All Communities',
      fetchError: 'Failed to fetch operational analysis data',
      fetchCommunityError: 'Failed to fetch community list',
      chart: {
        payFee: 'Payment Orders',
        repair: 'Repair Orders',
        inspection: 'Inspections',
        maintainance: 'Maintenance',
        itemIn: 'Purchase Orders',
        itemOut: 'Withdrawal Orders',
        carIn: 'Vehicle Entries',
        personIn: 'Door Openings',
        contract: 'Contracts'
      }
    }
  },
  zh: {
    operationalAnalysis: {
      allCommunities: '全部小区',
      fetchError: '获取运营分析数据失败',
      fetchCommunityError: '获取小区列表失败',
      chart: {
        payFee: '缴费订单数',
        repair: '报修订单数',
        inspection: '巡检数',
        maintainance: '保养数',
        itemIn: '采购订单数',
        itemOut: '领用订单数',
        carIn: '车辆进场数',
        personIn: '开门记录',
        contract: '签订合同数'
      }
    }
  }
}